import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Step = ({ n, children }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
    <Box component="strong" sx={{ color: 'text.primary' }}>
      Step {n}
    </Box>{' '}
    — {children}
  </Typography>
);

const MFASteps = () => {
  return (
    <Grid size={12}>
      <Box
        sx={{
          textAlign: 'left',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          p: 2
        }}
      >
        <Step n={1}>
          Download an Authenticator App. Microsoft Authenticator (
          <a
            href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en_IN&gl=US"
            target="_blank"
            rel="noreferrer"
          >
            Android
          </a>{' '}
          |{' '}
          <a
            href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
            target="_blank"
            rel="noreferrer"
          >
            iOS
          </a>
          ) or Google Authenticator (
          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
            target="_blank"
            rel="noreferrer"
          >
            Android
          </a>{' '}
          |{' '}
          <a
            href="https://apps.apple.com/us/app/google-authenticator/id388497605"
            target="_blank"
            rel="noreferrer"
          >
            iOS
          </a>
          ).
        </Step>
        <Step n={2}>Open the Authenticator App and scan the QR code.</Step>
        <Typography variant="body2" color="text.secondary">
          <Box component="strong" sx={{ color: 'text.primary' }}>
            Step 3
          </Box>{' '}
          — Select the account and enter the 6 digit authentication code.
        </Typography>
      </Box>
    </Grid>
  );
};

export default MFASteps;
